export default __webpack_public_path__ + "static/media/la_capellemini.60c25828.jpg";